import { config } from "../utils/config";
import { getImprintInfo, getImprintProcessValueForHolographicTemp } from "../utils/customization";
import { merchantisePantoneColor } from "../utils/image";
export default class CustomizeInfo {
    
    customizationInfo: Array<any>
    userSelectionInfo: Array<any>
    maxCharacterInfo: Array<any>
    shippingInfo: Array<any>

    constructor(productSpecification, customizationInfo, customizationType, variableAttributes: any = null) {
        const { deliveryInfo, maxLines, maxCharsPerLine } = config('metaTextInfo');

        this.customizationInfo = this.getProductCustomizationDetails(productSpecification, customizationInfo, customizationType, variableAttributes)
        this.userSelectionInfo = productSpecification?.selectableAttributes?.map((attribute) => attribute.displayKey && attribute.displayValue && {
            attribute: attribute.displayKey,
            value: attribute.displayValue,
            renderType: attribute.renderType,
            multiDisplayValue: attribute.multiDisplayValue,            
            key: attribute.key,            
            attributeValues: attribute.attributeValues,
            originalAttributeValue: attribute.originalAttributeValue || attribute.value,
            originalAttributeKey: attribute.originalAttributeKey || attribute.attributeKey
        }) ?? [];
        this.maxCharacterInfo = this.getProcessedSpecification(productSpecification, [maxLines, maxCharsPerLine]);
        this.shippingInfo =  this.getProcessedSpecification(productSpecification, [deliveryInfo]);

    }

    private getProductCustomizationDetails = (productSpecification, customizationInfo, customizationType, variableAttributes) => {
        const { deliveryInfo, maxLines, maxCharsPerLine } = config('metaTextInfo');
        const attributesToIgnore = (productSpecification?.selectableAttributes?.map(attribute => attribute.key) ?? []).concat([maxLines, maxCharsPerLine, deliveryInfo]);
        const attributeList = productSpecification?.specifications?.filter(({key})=> !attributesToIgnore.includes(key)).map(({key})=> key);
        return this.getProcessedSpecification(productSpecification, attributeList, getImprintInfo(customizationInfo, customizationType), variableAttributes) || [];
    };

    private getProcessedSpecification = (productSpecification, attributeList, imprintColorInfo: any = null, variableAttributes: any = null) => {
        let info: Array<object> = [], imprintInfoAdded = false;
        const imprintProcessValue = variableAttributes && getImprintProcessValueForHolographicTemp(variableAttributes);
        productSpecification?.specifications?.forEach((attribute) => {
            if(imprintProcessValue && attribute.key === 'Imprint_Process'){
                attribute.displayValue = imprintProcessValue;
            }
            if (config('metaTextInfo').imprintColor === attribute.key && imprintColorInfo) {
                info.push(imprintColorInfo);
                imprintInfoAdded = true;
            } 
            else if(attributeList.includes(attribute.key)){
                info.push({
                    attribute: attribute.displayName,
                    value: Array.isArray(attribute.displayValue)? attribute.displayValue.join(','): attribute.displayValue,
                    key: attribute.key
                });
            }
        })
        if (!imprintInfoAdded && imprintColorInfo) info.push(imprintColorInfo);
        return info;
    }; 
}

